import CalculationPosition from '../../../types/api/calculation-position'

export function setEditing(
    columns: any[],
    onSave: (record: CalculationPosition, formValues: any) => void,
    onEditingSessionChange?: (documentId: string, active: boolean) => void
): any[] {
    return columns.map(item => {
        if (item.children) {
            return {
                ...item,
                children: setEditing(item.children, onSave, onEditingSessionChange),
            }
        }

        if (item.editable) {
            return {
                ...item,
                onCell: (record: any, index: number) => {
                    const initialProps = item.onCell ? item.onCell(record, index) : {}

                    return {
                        ...initialProps,
                        record: record,
                        title: item.title,
                        dataIndex:
                            'dataIndex' in initialProps ? initialProps.dataIndex : item.dataIndex,
                        editable:
                            'editable' in initialProps ? initialProps.editable : item.editable,
                        FormItem: item.FormItem,
                        handleSave: onSave,
                        onEditingSessionChange,
                        relationPath:
                            'relationPath' in initialProps
                                ? initialProps.relationPath
                                : item.relationPath,
                        validator: item.validator,
                        fieldDescriptors:
                            'fieldDescriptors' in initialProps
                                ? initialProps.fieldDescriptors
                                : item.fieldDescriptors,
                    }
                },
            }
        }

        if (item.validator) {
            return {
                ...item,
                onCell: (record: any, index: number) => {
                    const initialProps = item.onCell ? item.onCell(record, index) : {}

                    return {
                        ...initialProps,
                        record: record,
                        title: item.title,
                        dataIndex: item.dataIndex,
                        editable: false,
                        validator: item.validator,
                    }
                },
            }
        }

        return item
    })
}

export function getCheckedKeys(columnItems: any[], keys: any[] = []): any[] {
    keys.push(
        ...columnItems.map(item => {
            keys.push(item.dataIndex)
            return item.children ? getCheckedKeys(item.children, keys) : item.dataIndex
        })
    )

    return keys
}

export function getTreeItems(columnItems: any[]): any {
    return columnItems.map(item => {
        return {
            title: item.title,
            key: item.dataIndex,
            children: item.children ? getTreeItems(item.children) : [],
        }
    })
}
